import { IonCol, IonRow } from '@ionic/react';
import '@ionic/react/css/ionic-swiper.css';
import React from 'react';
import TextHelper from '../../utils/TextHelper';
import './ListGrid.scss';

export default function ListGrid(props: { item: any, index: number, itemType: string, arrayLength: number, }) {
  const { item, index, itemType, arrayLength } = props;

  let iconPath;
  let folderName = 'default';

  switch (item.type) {
    case 'TOPIC':
      folderName = 'topics';
      break;
    case 'PROCESSGOAL':
    case 'GOAL':
      folderName = 'goals';
      break;
    case 'OPTION':
      folderName = 'options';
      break;
    case 'DECISION':
      folderName = 'decisions';
      break;
    default:
      break;
  }

  try {
    // eslint-disable-next-line
    iconPath = require(`../../assets/${folderName}/${item?.icon}`);
  } catch (error) {
    console.log('iconPath error', item);
  }

  let iconSizeSm = '';
  let iconSizeXs = '';
  let iconSizeMd = '';
  let iconSizeXl = '';
  let iconSizeLg = '';
  let descSizeSm = '';
  let descSizeXs = '';
  let descSizeMd = '';
  let descSizeXl = '';
  let descSizeLg = '';
  let nameToBeRendered: any;
  let descToBeRendered: any;

  if (itemType === 'popular-option') {
    nameToBeRendered = item.name;
    descToBeRendered = item.description;
    iconSizeSm = '1.3';
    iconSizeXs = '2';
    iconSizeMd = '2.7';
    iconSizeXl = '1.4';
    iconSizeLg = '2';
    descSizeSm = '10.7';
    descSizeXs = '10';
    descSizeMd = '9.3';
    descSizeXl = '10.6';
    descSizeLg = '10';
  } else if (itemType === 'default') {
    nameToBeRendered = item.name;
    descToBeRendered = item.description;
    iconSizeSm = '1.2';
    iconSizeXs = '2';
    iconSizeMd = '1.2';
    iconSizeXl = '0.6';
    iconSizeLg = '0.8';
    descSizeSm = '10.7';
    descSizeXs = '10';
    descSizeMd = '9.3';
    descSizeXl = '10.6';
    descSizeLg = '10';
  } else if (itemType === 'process-goal-additional-resources') {
    nameToBeRendered = item.linkName;
    descToBeRendered = item.urlString;
    iconSizeSm = '1.2';
    iconSizeXs = '2';
    iconSizeMd = '1.2';
    iconSizeXl = '0.6';
    iconSizeLg = '0.8';
    descSizeSm = '10.7';
    descSizeXs = '10';
    descSizeMd = '9.3';
    descSizeXl = '10.6';
    descSizeLg = '10';
  } else {
    nameToBeRendered = item.linkName;
    descToBeRendered = item.urlString;
    iconSizeSm = '2';
    iconSizeXs = '2';
    iconSizeMd = '2';
    iconSizeXl = '2';
    iconSizeLg = '2';
    descSizeSm = '10';
    descSizeXs = '10';
    descSizeMd = '10';
    descSizeXl = '10';
    descSizeLg = '10';
  }
  return (
    <IonRow
      className="popular-option-container"
      style={(arrayLength - 1) !== index ? { borderBottom: '1px solid #CBCBCB' } : {}}
    >
      <IonCol
        sizeSm={iconSizeSm}
        sizeXs={iconSizeXs}
        sizeMd={iconSizeMd}
        sizeXl={iconSizeXl}
        sizeLg={iconSizeLg}
        style={{ paddingTop: '0px', paddingLeft: '0px', paddingBottom: '0px' }}
      >
        <div className="popular-option-icon" style={{ background: '#E5DCF2' }}>
          <img src={iconPath} alt="" style={{ width: '32px', height: '32px' }} />
        </div>
      </IonCol>
      <IonCol
        sizeSm={descSizeSm}
        sizeXs={descSizeXs}
        sizeMd={descSizeMd}
        sizeXl={descSizeXl}
        sizeLg={descSizeLg}
        style={{ paddingTop: '0px', paddingLeft: '0px', paddingBottom: '0px' }}
      >
        <IonRow className="popular-option-title">
          {TextHelper.stripHTML(nameToBeRendered)}
        </IonRow>
        <IonRow className="popular-option-description">
          {descToBeRendered ? `${TextHelper.stripHTML(descToBeRendered)?.substring(0, 69)}...` : ''}
        </IonRow>
      </IonCol>
      <IonCol size="8" />
    </IonRow>
  );
}
